import React from 'react';
import TextField56 from './TextField56.jsx';
import List from './List.jsx';

// Embedded-label field + canonical AfriMed List, for finite form choices.
export default function TextFieldMenu({id, name, label, value, placeholder, options = [], onChange, disabled = false, required = false}) {
 const [open,setOpen]=React.useState(false);
 const root=React.useRef(null);
 const menuId=`${id}-options`;
 const close=()=>{setOpen(false);root.current?.querySelector('[aria-haspopup]')?.focus();};
 React.useEffect(()=>{
  if(!open)return;
  const outside=e=>{if(!root.current?.contains(e.target))setOpen(false);};
  document.addEventListener('pointerdown',outside);
  return()=>document.removeEventListener('pointerdown',outside);
 },[open]);
 React.useEffect(()=>{if(open)root.current?.querySelector('[aria-selected="true"], [role="option"]')?.focus();},[open]);
 function keydown(e){
  if(e.key==='Escape'){e.preventDefault();close();}
  if(e.key==='Tab'&&open)close();
  if(!['ArrowDown','ArrowUp','Home','End'].includes(e.key))return;
  e.preventDefault();if(!open){setOpen(true);return;}
  const buttons=[...root.current.querySelectorAll('[role="option"]')];
  const current=buttons.indexOf(document.activeElement);
  const index=e.key==='Home'?0:e.key==='End'?buttons.length-1:(current+(e.key==='ArrowDown'?1:-1)+buttons.length)%buttons.length;
  buttons[index]?.focus();
 }
 return <div ref={root} className="relative" onKeyDown={keydown}>
  <TextField56 id={id} name={name} as="button" label={label} value={options.find(o=>o.value===value)?.label||''} placeholder={placeholder} tone="surface" disabled={disabled} onTriggerClick={()=>setOpen(v=>!v)} triggerAriaLabel={label} triggerAriaHaspopup="listbox" triggerAriaExpanded={open} triggerProps={{'aria-controls':menuId,'aria-required':required}} triggerTrailingInteractive trailingSlot={<img src="/icons/appointments/dashboard/expand_more.svg" alt="" className={`h-5 w-5 ${open?'rotate-180':''}`} />} />
  {open&&<div id={menuId} role="listbox" aria-label={label} className="absolute z-[90] mt-2 w-full max-h-72 overflow-auto rounded-xl bg-surface shadow-[var(--elev-4)]">
   <List paddingY={3} itemMinHeight={48} items={options.map(option=>({title:option.label,role:'option',selected:option.value===value,divider:false,truncateTitle:false,onClick:()=>{onChange({target:{name,value:option.value}});close();}}))}/>
  </div>}
 </div>;
}
